<template>
  <div class="line-elevation" style="position:fixed;left:0;right:0;bottom:0;z-index:1000">
    <button
      class="button is-small is-borderless"
      style="position:absolute;top:1rem;right:1rem;border:none;z-index:100"
      @click="close()"
    >
      <i class="fa fa-times"></i>
    </button>
    <div id="lineGraph"></div>
  </div>
</template>
<script>
import Plotly from "plotly.js-dist";
import { mapState } from "vuex";
var layout = {
  yaxis: { fixedrange: true },
  xaxis: { fixedrange: true },

  height: 300,
  title: "Line Elevation"
};
const chart_modalbar_options = {
  modeBarButtonsToRemove: [
    "zoom2d",
    "pan2d",
    "zoomIn2d",
    "zoomOut2d",
    "toImage",
    "select2d",
    "lasso2d",
    "autoScale2d",
    "resetScale2d",
    "hoverClosestCartesian",
    "hoverCompareCartesian",
    "zoom3d",
    "pan3d",
    "resetCameraDefault3d",
    "resetCameraLastSave3d",
    "hoverClosest3d",
    "orbitRotation",
    "tableRotation",
    "zoomInGeo",
    "zoomOutGeo",
    "resetGeo",
    "hoverClosestGeo",
    "sendDataToCloud",
    "hoverClosestGl2d",
    "hoverClosestPie",
    "toggleHover",
    "resetViews",
    "resetViewMapbox",
    "toggleSpikelines"
  ],
  responsive: true,
  displaylogo: false
};
export default {
  props: ["line_elevation"],
  created() {
    // Plotly.newPlot("lineGraph", data, layout, chart_modalbar_options);
  },
  computed: {
    ...mapState(["draw"])
  },
  methods: {
    close() {
      this.draw.delete("elevation-point");
      this.$emit("close");
    }
  },
  watch: {
    line_elevation: function() {
      if (!this.line_elevation) return;

      let trace = {
        y: [],
        mode: "lines",
        fill: "tozeroy"
      };
      trace.y = this.line_elevation.map(e => {
        return e[2];
      });

      layout.yaxis.range = [Math.min(...trace.y), Math.max(...trace.y)];

      Plotly.newPlot("lineGraph", [trace], layout, chart_modalbar_options);
      var myPlot = document.getElementById("lineGraph");
      myPlot.on("plotly_hover", data => {
        var feature = {
          id: "elevation-point",
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              this.line_elevation[data.points[0].pointIndex][0],
              this.line_elevation[data.points[0].pointIndex][1]
            ]
          },
          properties: { elevation: 1 }
        };
        var featureIds = this.draw.add(feature);
      });
    }
  }
};
</script>
